// extracted by mini-css-extract-plugin
module.exports = {"root":"Graph_root__2lKui","header":"Graph_header__3Roz1","options":"Graph_options__2bT5d"};